import { inputAnatomy } from "@chakra-ui/anatomy";

import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

import ThemeColorConstant from "constants/ThemeColorsConstant";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(inputAnatomy.keys);

const baseStyle = definePartsStyle({
  field: {
    borderRadius: "0px",
    borderColor: "black",
    border: "1px solid",
  },
});

const outline = definePartsStyle({
  field: {
    paddingY: "30px",

    _focus: {
      borderColor: ThemeColorConstant.secondaryColor, // Green outline on focus
    },
    _hover: {
      background: ThemeColorConstant.hover_background,
      borderColor: "black",
      border: "1px solid",
    },
  },
});

const outlineSelect = definePartsStyle({
  field: {
    height: "60px",

    _focus: {
      borderColor: ThemeColorConstant.secondaryColor, // Green outline on focus
    },
    _hover: {
      background: ThemeColorConstant.hover_background,
      borderColor: "black",
      border: "1px solid",
    },
  },
});

const unstyled = definePartsStyle({
  field: {
    border: "0px solid",
    borderRadius: "0px",
    borderColor: "black",

    height: "70px",

    _focus: {
      borderColor: ThemeColorConstant.secondaryColor, // Green outline on focus
    },
    _hover: {
      background: ThemeColorConstant.hover_background,
    },
  },
});

const accordionInput = definePartsStyle({
  field: {
    border: "1px solid",
    borderRadius: "0px",
    borderColor: "black",
    paddingX: "0px",
    paddingY: "0px",
    alignItems: "center",
    // height: "70px",

    _focus: {
      borderColor: ThemeColorConstant.secondaryColor, // Green outline on focus
    },
    _hover: {
      background: ThemeColorConstant.hover_background,
    },
  },
});

const ChakraUIInputStyling = defineMultiStyleConfig({
  baseStyle,
  variants: {
    outline,
    unstyled,
    accordionInput,
    outlineSelect,
  },
});

export default ChakraUIInputStyling;
